import { Component, Renderer2 } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from './shared/auth/auth.service';
declare var jquery:any;
declare var $ :any;
declare var App:any;
declare var FormSliderSwitcher:any;



import { NavigationStart } from '@angular/router';
import { HelpersService } from './shared/helpers/helpers.service';
import { Logging } from './logging';
import { TimeoutService } from './shared/timeout/timeout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  allowheader: boolean = true;

  constructor(private renderer: Renderer2, 
              private router: Router,
              private auth: AuthService,
              private helpers: HelpersService,
              private timeoutService: TimeoutService
            ){

    // Perform Route Specific Dom elemant Changes
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          
          //Add/remove some classes for login and register page
          if(event.url.includes('/login') || event.url.includes('/register')){

            this.renderer.addClass(document.body, 'pace-top');
            this.renderer.addClass(document.body, 'bg-white');

          }else{
            
            this.renderer.removeClass(document.body, 'pace-top');
            this.renderer.removeClass(document.body, 'bg-white');

          }

          if(event.url.includes('/transdetails'))
          {
            this.allowheader = false;
          }

          App.init();
          $("#datepicker-autoClose").datepicker({
            todayHighlight:!0,
            autoclose:!0,
            format: "yyyy-mm-dd"
          });
          

          let phoneInput = $("#phone_Number").intlTelInput({
            // initialCountry: "gh",
            initialCountry: "GH",
            separateDialCode: true,
            allowDropdown:false,
            geoIpLookup: function(callback) {
              $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
                var countryCode = (resp && resp.country) ? resp.country : "";
                callback(countryCode);
              });
            },

          });

          
          

          Logging.log('changed');
          Logging.log(auth.user());
          // Logging.log($("#phone_Number").intlTelInput("getExtension"));

           //enable system auto timeouts
        this.timeoutService.handleInactivity()
        .subscribe(inactive => {
          if(event.url.includes('/login') || event.url.includes('/register')){
            // might do something here
          }
          else
          {
           // helpers.flashDanger("You have been auto logged out becuase of inactivity.");
            this.auth.forceLogout();
          }
          
        });


        }
        window.scrollTo(0, 0);
      });

     
  }


  checkLogin(){
    return this.auth.isLoggedIn();
  }

  forceLogout(){
    if(this.checkLogin())
    {
      this.auth.forceLogout();
    }
    
  }

  

  title = 'app';
  
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts